import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
    siteKey: "6Le_AuYpAAAAAJ62I7XvUU9F5k9Deog_N7DAs2z7",
    loaderOptions: { useRecaptchaNet: true, autoHideBadge: true }
});